// ----------------------------------------------------------------------

export default function Card(theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.customShadows.z8,
          borderRadius: theme.shape.borderRadiusMd,
          position: 'relative',
          zIndex: 0,
          border: `1px solid ${theme.palette.grey[200]}`
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { 
          variant: 'h6',
          fontWeight: 600,
          color: theme.palette.text.primary
        },
        subheaderTypographyProps: { 
          variant: 'body2',
          color: theme.palette.text.secondary
        }
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0),
          borderBottom: `1px solid ${theme.palette.grey[100]}`,
          marginBottom: theme.spacing(2)
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          '&:last-child': {
            paddingBottom: theme.spacing(3)
          }
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 3, 3),
          gap: theme.spacing(1)
        }
      }
    }
  };
}
